(() => {
  'use strict';

  const OUTLINK_SELECTOR = 'a[data-tii-outlink]';

  function markOutlinkActive(link) {
    link.classList.add('tii-outlink--active');
    link.setAttribute('aria-busy', 'true');
    window.setTimeout(() => {
      link.classList.remove('tii-outlink--active');
      link.removeAttribute('aria-busy');
    }, 1200);
  }

  document.addEventListener('pointerdown', (event) => {
    const link = event.target.closest?.(OUTLINK_SELECTOR);
    if (link) markOutlinkActive(link);
  }, {passive: true});

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.(OUTLINK_SELECTOR);
    if (!link) return;

    const destination = link.href;
    if (link.dataset.gtagEnabled === 'true' && typeof window.gtag === 'function') {
      window.gtag('event', 'Click', {
        event_category: 'Outlink',
        event_label: 'Outlink-Click',
        value: destination
      });
    }

    if (link.dataset.facebookEnabled === 'true' && typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'OutlinkClick', {ExternalLink: destination});
    }

    document.dispatchEvent(new CustomEvent('tii:outlink', {
      detail: {
        productId: link.dataset.productid || '',
        destination
      }
    }));
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll(`${OUTLINK_SELECTOR}[aria-busy="true"]`).forEach((link) => {
      link.classList.remove('tii-outlink--active');
      link.removeAttribute('aria-busy');
    });
  });

  customElements.whenDefined('predictive-search').then(() => {
    const PredictiveSearch = customElements.get('predictive-search');
    if (!PredictiveSearch || PredictiveSearch.prototype.tiiSafeSearchInstalled) return;

    PredictiveSearch.prototype.tiiSafeSearchInstalled = true;
    PredictiveSearch.prototype.getSearchResults = function getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      const url = `${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`;
      fetch(url, {
        signal: this.abortController.signal,
        headers: {Accept: 'text/html'},
        credentials: 'same-origin'
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Predictive search request failed: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const section = parsed.querySelector('#shopify-section-predictive-search');
          if (!section) throw new Error('Predictive search returned an invalid response');

          const resultsMarkup = section.innerHTML;
          this.allPredictiveSearchInstances.forEach((instance) => {
            instance.cachedResults[queryKey] = resultsMarkup;
          });
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.name === 'AbortError' || error?.code === 20) return;

          this.removeAttribute('loading');
          this.removeAttribute('results');
          this.predictiveSearchResults.innerHTML = '';
          this.closeResults(false);
          this.setLiveRegionText('Search suggestions are temporarily unavailable. Press Enter to search.');
          console.warn('[TII] Predictive search recovered from an invalid response.');
        });
    };
  });
})();
